<div class="modal-title" mat-dialog-title>
  <div class="row">
    <div class="col-10">
      <h3>{{ 'AdvancedFilters' | translate }}</h3>
    </div>
    <div class="col-2">
      <button mat-dialog-action class="btnLink closeModal text-right" (click)="close()">
        <fa-icon [icon]="faTimesCircle"></fa-icon>
      </button>
    </div>
  </div>
</div>


<mat-dialog-content class="filter-modal">
  <div class="modal-text">
    <form class="" name="form" [formGroup]="form" (ngSubmit)="onSubmit()">

      <!--Vehicle Type-->
      <div class="form-group row">
        <label class="col-md-4 col-form-label" for="vehicleType">{{ 'VehicleType' | translate }}</label>
        <div class="col-md-8">
          <mat-form-field appearance="none">

            <mat-select panelClass="select-filter"  class="form-control new-detials-filed select"
              formControlName="vehicleType" [multiple]="true" #multiSelect disableOptionCentering>
              <mat-option >
                <ngx-mat-select-search [formControl]="vehicleTypeFilterCtrl"
                 [noEntriesFoundLabel]="noEntriesFoundLabel"
                 placeholderLabel="{{ 'Search' | translate }}"
                 ></ngx-mat-select-search>
              </mat-option>

              <mat-option *ngFor="let vehicleType of filteredvehicleTypeMulti | async" [value]="vehicleType.value">
                {{vehicleType.text}}
              </mat-option>
            </mat-select>
          </mat-form-field>
          <div class="invalid-feedback">
            <div class="validation-error"><fa-icon class="mr-1" [icon]="faTimesCircle"></fa-icon>{{ 'ThisFiledIsRequired' | translate }}</div>
          </div>
        </div>
      </div>

      <!--Vehicle Class-->
      <div class="form-group row">
        <label class="col-md-4 col-form-label" for="vehicleClass">{{ 'VehicleClass' | translate }}</label>
        <div class="col-md-8">
          <mat-form-field appearance="none">
            <mat-select panelClass="select-filter" [multiple]="true" class="form-control new-detials-filed select"
              formControlName="vehicleClass"  disableOptionCentering>
              <mat-option >
                <ngx-mat-select-search [formControl]="vehicleClassesFilterCtrl"
                 [noEntriesFoundLabel]="noEntriesFoundLabel"
                 placeholderLabel="{{ 'Search' | translate }}"
                 ></ngx-mat-select-search>
              </mat-option>
              <mat-option *ngFor="let vehicleClass of filteredVehicleClassesMulti | async" [value]="vehicleClass.value">
                {{vehicleClass.text}}
              </mat-option>
            </mat-select>
          </mat-form-field>
          <div class="invalid-feedback">
            <div class="validation-error"><fa-icon class="mr-1" [icon]="faTimesCircle"></fa-icon>{{ 'ThisFiledIsRequired' | translate }}</div>
          </div>
        </div>
      </div>

      <!--Fuel Type-->
      <div class="form-group row">
        <label class="col-md-4 col-form-label" for="fuelType">{{ 'FuelType' | translate }}</label>
        <div class="col-md-8">
          <mat-form-field appearance="none">
            <mat-select panelClass="select-filter" multiple class="form-control new-detials-filed select"
              formControlName="fuelType"  disableOptionCentering>
              <mat-option >
                <ngx-mat-select-search [formControl]="fuelTypesFilterCtrl"
                 [noEntriesFoundLabel]="noEntriesFoundLabel"
                 placeholderLabel="{{ 'Search' | translate }}"
                 ></ngx-mat-select-search>
              </mat-option>
              <mat-option *ngFor="let fuelType of filteredFuelTypesMulti | async" [value]="fuelType.value">
                {{fuelType.text}}
              </mat-option>
            </mat-select>
          </mat-form-field>
          <div class="invalid-feedback">
            <div class="validation-error"><fa-icon class="mr-1" [icon]="faTimesCircle"></fa-icon>{{ 'ThisFiledIsRequired' | translate }}</div>
          </div>
        </div>
      </div>

      <!--Price (Daily)
      <div class="form-group row">
        <label class="col-md-4 col-form-label" for="fuelType">{{ 'Price(Daily)' | translate }}</label>
        <div class="col-md-8">
          <div class="row">
            <div class="col-md-6 pr-md-0 mb-2">
              <div class="input-group">
                <input placeholder="{{ 'PriceFrom' | translate }}" type="number" class="form-control"
                  formControlName="PriceFrom" required />
                <div class="input-group-append">
                  <span class="input-group-text">
                    {{currency}}
                  </span>
                </div>
              </div>
              <div class="invalid-feedback">
                <div class="validation-error"><fa-icon class="mr-1" [icon]="faTimesCircle"></fa-icon>{{ 'ThisFiledIsRequired' | translate }}</div>
              </div>

            </div>
            <div class="col-md-6">
              <div class="input-group">
                <input placeholder="{{ 'PriceTo' | translate }}" type="number" class="form-control"
                  formControlName="PriceTo" required />
                <div class="input-group-append">
                  <span class="input-group-text">
                    {{currency}}
                  </span>
                </div>
              </div>
              <div class="invalid-feedback">
                <div class="validation-error"><fa-icon class="mr-1" [icon]="faTimesCircle"></fa-icon>{{ 'ThisFiledIsRequired' | translate }}</div>
              </div>
            </div>
          </div>
          <div *ngIf="showValidPrice">
            <div class="validation-error"><fa-icon class="mr-1" [icon]="faTimesCircle"></fa-icon>{{ 'ThePriceFromShouldBeLessthanPriceTo' | translate }}</div>
          </div>
        </div>
      </div>
      -->
      <!--Additional Services & Charges-->
      <div class="form-group row">
        <label class="col-md-4 col-form-label" for="AdditionalService">{{ 'Services&Charges' | translate }}</label>
        <div class="col-md-8">
          <mat-form-field appearance="none">
            <mat-select panelClass="select-filter" multiple class="form-control new-detials-filed select"
              formControlName="AdditionalService"  disableOptionCentering>
              <mat-option >
                <ngx-mat-select-search [formControl]="additionalServicesFilterCtrl"
                 [noEntriesFoundLabel]="noEntriesFoundLabel"
                 placeholderLabel="{{ 'Search' | translate }}"
                 ></ngx-mat-select-search>
              </mat-option>
              <mat-option *ngFor="let AdditionalService of filteredAdditionalServicesMulti | async" [value]="AdditionalService.value">
                {{AdditionalService.text}}
              </mat-option>
            </mat-select>
          </mat-form-field>
          <div class="invalid-feedback">
            <div class="validation-error"><fa-icon class="mr-1" [icon]="faTimesCircle"></fa-icon>{{ 'ThisFiledIsRequired' | translate }}</div>
          </div>
        </div>
      </div>

      <!--OdoMeter-->
      <div class="form-group mb-2 row" *ngIf="searchType==VehicleSearchTypeEnum.vehicleSearch">
        <label class="col-md-4 col-form-label mt-3">{{ 'Odometer' | translate }}</label>
        <div class="col-md-8">
          <div class="slideContainer  mt-4 ">
            <mat-slider  class="mb-2" min="0" max="100000" formControlName="odometer"></mat-slider>
          </div>
        </div>
      </div>

      <!--Full Tank-->
      <div class="form-group row" *ngIf="searchType==VehicleSearchTypeEnum.vehicleSearch">
        <label class="col-md-4 col-form-label">{{ 'FuelLevel' | translate }}</label>
        <div class="col-md-8">
          <mat-checkbox disableRipple class="mr-3 return-ar" formControlName="isFullRequired">
          {{ 'IsFullTank' | translate }}
          </mat-checkbox>
        </div>
      </div>

      <!--Add On-->
      <div class="form-group row" *ngIf="searchType==VehicleSearchTypeEnum.vehicleSearch">
        <label class="col-md-4 col-form-label" for="addOn">{{ 'AddOn' | translate }}</label>
        <div class="col-md-8">
          <mat-form-field appearance="none">
            <mat-select multiple panelClass="select-filter" class="form-control new-detials-filed select"
              formControlName="addOn" disableOptionCentering>
              <mat-option >
                <ngx-mat-select-search [formControl]="featuresFilterCtrl"
                 [noEntriesFoundLabel]="noEntriesFoundLabel"
                 placeholderLabel="{{ 'Search' | translate }}"
                 ></ngx-mat-select-search>
              </mat-option>
              <mat-option *ngFor="let feature of filteredFeaturesMulti | async" [value]="feature.value">
                {{feature.text}}
              </mat-option>
            </mat-select>
          </mat-form-field>

        </div>
      </div>

      <!--Gearbox-->
      <div class="form-group row">
        <label class="col-md-4 col-form-label" for="gearbox">{{ 'Gearbox' | translate }}</label>
        <div class="col-md-8">
          <mat-form-field appearance="none">
            <mat-select  panelClass="select-filter" class="form-control new-detials-filed select"
              formControlName="gearbox"  disableOptionCentering>
              <mat-option >
              
                <ngx-mat-select-search [formControl]="gearboxsFilterCtrl"
                [noEntriesFoundLabel]="noEntriesFoundLabel"
                placeholderLabel="{{ 'Search' | translate }}"
                ></ngx-mat-select-search>

              </mat-option>
              <mat-option>None</mat-option>
              <mat-option *ngFor="let gearbox of filteredGearboxsMulti | async" [value]="gearbox.value">
                {{gearbox.text}}
              </mat-option>
            </mat-select>
          </mat-form-field>
          <div class="invalid-feedback">
            <div class="validation-error"><fa-icon class="mr-1" [icon]="faTimesCircle"></fa-icon>{{ 'ThisFiledIsRequired' | translate }}</div>
          </div>
        </div>
      </div>


      <!--Storage-->
      <div class="form-group row">
        <label class="col-md-4 col-form-label" for="storage">{{ 'Storage' | translate }}</label>
        <div class="col-md-8">
          <mat-form-field appearance="none">
            <mat-select panelClass="select-filter" class="form-control new-detials-filed select"
              formControlName="storage"  disableOptionCentering>
              <mat-option >
                <ngx-mat-select-search [formControl]="storagesFilterCtrl"
                 [noEntriesFoundLabel]="noEntriesFoundLabel"
                 placeholderLabel="{{ 'Search' | translate }}"
                 ></ngx-mat-select-search>
              </mat-option>
              <mat-option>None</mat-option>
              <mat-option *ngFor="let storage of filteredStoragesMulti | async" [value]="storage.value">
                {{storage.text}}
              </mat-option> 
            </mat-select>
          </mat-form-field>
          <div class="invalid-feedback">
            <div class="validation-error"><fa-icon class="mr-1" [icon]="faTimesCircle"></fa-icon>{{ 'ThisFiledIsRequired' | translate }}</div>
          </div>
        </div>
      </div>

      <!--Passenger-->
      <div class="form-group row">
        <label class="col-md-4 col-form-label" for="passenger">{{ 'Passenger' | translate }}</label>
        <div class="col-md-8">
          <mat-form-field appearance="none">
            <mat-select panelClass="select-filter" class="form-control new-detials-filed select"
              formControlName="passenger"  disableOptionCentering>
              <mat-option >
                <ngx-mat-select-search [formControl]="passengersFilterCtrl"
                 [noEntriesFoundLabel]="noEntriesFoundLabel"
                 placeholderLabel="{{ 'Search' | translate }}"
                 ></ngx-mat-select-search>
              </mat-option>
              <mat-option>None</mat-option>
              <mat-option *ngFor="let passenger of filteredPassengersMulti | async" [value]="passenger.value">
                {{passenger.text}}
              </mat-option>
            </mat-select>
          </mat-form-field>
          <div class="invalid-feedback">
            <div class="validation-error"><fa-icon class="mr-1" [icon]="faTimesCircle"></fa-icon>{{ 'ThisFiledIsRequired' | translate }}</div>
          </div>
        </div>
      </div>

      <!--Make-->
      <div class="form-group row"
        *ngIf="searchType==VehicleSearchTypeEnum.MakeModelYearSearch||searchType==VehicleSearchTypeEnum.vehicleSearch">
        <label class="col-md-4 col-form-label" for="make">{{ 'Make' | translate }}</label>
        <div class="col-md-8">
          <mat-form-field appearance="none">
            <mat-select panelClass="select-filter" class="form-control new-detials-filed select" formControlName="make"
             (selectionChange)="makeIDChanged($event.value)" disableOptionCentering >

            <mat-option >
              <ngx-mat-select-search [formControl]="makesFilterCtrl"
               [noEntriesFoundLabel]="noEntriesFoundLabel"
               placeholderLabel="{{ 'Search' | translate }}" 
               ></ngx-mat-select-search>
            </mat-option>
            <mat-option *ngFor="let make of filteredMakesMulti | async " [value]="make.value">
              {{make.text}}
            </mat-option>
          </mat-select>
          </mat-form-field>



          <!-- Eman Add it for search makes -->
          <!-- <mat-form-field appearance="none">
            <mat-select panelClass="select-filter" class="form-control new-detials-filed select" [formControl]="makeCtrl"  #makeSelect>
              <mat-option>
                <ngx-mat-select-search placeholderLabel="Search"  [formControl]="makeFilterCtrl"></ngx-mat-select-search>
              </mat-option>
              <mat-option *ngFor="let make of filteredMakes | async" [value]="make">
                {{make.text}}
              </mat-option>
            </mat-select>
          </mat-form-field> -->



          <div class="invalid-feedback">
            <div class="validation-error"><fa-icon class="mr-1" [icon]="faTimesCircle"></fa-icon>{{ 'ThisFiledIsRequired' | translate }}</div>
          </div>
        </div>
      </div>

      <!--Model-->
      <div class="form-group row"
        *ngIf="searchType==VehicleSearchTypeEnum.MakeModelYearSearch||searchType==VehicleSearchTypeEnum.vehicleSearch">
        <label class="col-md-4 col-form-label" for="model">{{ 'Model' | translate }}</label>
        <div class="col-md-8">
          <mat-form-field appearance="none">
            <mat-select panelClass="select-filter" class="form-control new-detials-filed select" formControlName="model"
               disableOptionCentering>
              <mat-option >
                <ngx-mat-select-search [formControl]="modelsFilterCtrl"
                 [noEntriesFoundLabel]="noEntriesFoundLabel"
                 placeholderLabel="{{ 'Search' | translate }}"
                 ></ngx-mat-select-search>
                 </mat-option>
              <mat-option *ngFor="let model of filteredModelsMulti | async" [value]="model.value">
                {{model.text}}
              </mat-option>
            </mat-select>
          </mat-form-field>
          <div class="invalid-feedback">
            <div class="validation-error"><fa-icon class="mr-1" [icon]="faTimesCircle"></fa-icon>{{ 'ThisFiledIsRequired' | translate }}</div>
          </div>
        </div>
      </div>

      <!--Year-->
      <div class="form-group row"
        *ngIf="searchType==VehicleSearchTypeEnum.MakeModelYearSearch||searchType==VehicleSearchTypeEnum.vehicleSearch">
        <label class="col-md-4 col-form-label" for="year">{{ 'Year' | translate }}</label>
        <div class="col-md-8">
          <input class="form-control" type="number" formControlName="year" />

          <div class="invalid-feedback">
            <div class="validation-error"><fa-icon class="mr-1" [icon]="faTimesCircle"></fa-icon>{{ 'ThisFiledIsRequired' | translate }}</div>
          </div>
        </div>
      </div>

      <!--Free Policies-->
      <div class="form-group row">
        <label class="col-md-4 col-form-label" for="freePolicies">{{ 'FreePolicies' | translate }}</label>
        <div class="col-md-8">
          <mat-form-field appearance="none">
            <mat-select panelClass="select-filter" multiple class="form-control new-detials-filed select"
              formControlName="freePolicies"  disableOptionCentering>
              
              <mat-option >
                <ngx-mat-select-search [formControl]="freePoliciesFilterCtrl"
                 [noEntriesFoundLabel]="noEntriesFoundLabel"
                 placeholderLabel="{{ 'Search' | translate }}"
                 ></ngx-mat-select-search>
                 </mat-option>
               
              <mat-option *ngFor="let freePolicy of filteredFreePoliciesMulti | async" [value]="freePolicy.value">
                {{freePolicy.text | translate}}
              </mat-option>
            </mat-select>
          </mat-form-field>
          <div class="invalid-feedback">
            <div class="validation-error"><fa-icon class="mr-1" [icon]="faTimesCircle"></fa-icon>{{ 'ThisFiledIsRequired' | translate }}</div>
          </div>
        </div>
      </div>

      <!--Have Promotion Campaigns-->
      <div class="form-group row mb-4">
        <label class="col-md-4 col-form-label pt-3" for="promotionCampaigns">{{ 'PromotionCampaigns' | translate }}</label>
        <div class="col-md-8">
          <mat-radio-group formControlName="promotionCampaigns">

            <mat-radio-button #button (click)="checkState(button)" class="mt-3 mr-3" [value]="true">{{ 'Yes' | translate }}</mat-radio-button>
            <mat-radio-button #button1 (click)="checkState(button1)" class="mt-3 mr-3" [value]="false">{{ 'No' | translate }}</mat-radio-button>
          </mat-radio-group>
        </div>
      </div>



      <div class="form-group row ">
        <div class="col-md-12 mt-6">
          <button type="submit" class="btn default-btn mr-3 mat-button mat-button-base">{{ 'Apply' | translate
            }}</button>
          <button type="reset" (click)="cancel()" class="btn default-cancel-btn" mat-button>{{ 'Cancel' | translate }}</button>
        </div>
      </div>
    </form>

  </div>
</mat-dialog-content>
